import { Icon } from "./Icon.tsx";

/** "Save copy as" icon for icon-only buttons — two overlapping rectangles, same style as RenameIcon.tsx/DownloadIcon.tsx. */
export function DuplicateIcon() {
  return (
    <Icon>
      <rect x="8" y="8" width="12" height="12" rx="2" />
      <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
    </Icon>
  );
}
